const orderRouter = {
  path: '',
  component: () => import('@/layout/orderHeader'),
  children: [
    {
      path: '/cart',
      name: 'Cart',
      meta: { title: '进货单' },
      component: () => import(/* webpackChunkName: "order" */ '@/pages/cart')
    },
    {
      path: '/foreign',
      name: 'Foreign',
      meta: { title: '外汇订单' },
      component: () => import(/* webpackChunkName: "order" */ '@/pages/foreign')
    },
    {
      path: '/deposit',
      name: 'Deposit',
      meta: { title: '商家确认' },
      component: () => import(/* webpackChunkName: "order" */ '@/pages/submitOrder/pages/deposit')
    }
  ]
}

export default orderRouter
